import React from 'react';
import { Button } from 'antd';

export default class ResendInviteButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      title: "Re-send Invite"
    }
  }

  handleClick = () => {
    this.setState({isSubmitting: true, title: "Sending"})
    this.props.onResendInvite(this.props.email).then(()=> {
      this.setState({isSubmitting: false, title: "Sent!"})
      setTimeout( () => this.setState({title: "Re-send Invite"}) , 2000)
    })

  }

  render() {
    return (<Button loading={this.state.isSubmitting} onClick={()=> this.handleClick()} style={{fontSize: '13px'}} type="" icon="" >{this.state.title}</Button>);
  }
}



// WEBPACK FOOTER //
// ./src/enterprise/members/ResendInviteButton.js